import axios from '../host';
export const SET_TRAINER_INFO = 'SET_TRAINER_INFO';

export const setTrainerInfo = (val) => async (dispatch) => {
  return dispatch({
    type: SET_TRAINER_INFO,
    payload: { value: val },
  });
};
